// extracted by mini-css-extract-plugin
export default {"filters":"src-components-Filter-next-components-SbFiltersDrawer__filters--EEgkY","footer":"src-components-Filter-next-components-SbFiltersDrawer__footer--MPoDp"};